/**
 * Divide an array into multiple sub-arrays.
 *
 * @param arr
 * @param size
 */
export const chunk = <T>(arr: T[], size: number): T[][] =>
	Array.from({ length: Math.ceil(arr.length / size) }, (v, i) => arr.slice(i * size, i * size + size));
